import { Container, Grid, Typography } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import chisti from "../../../assets/imgs/team/takbir-muna-academy-khaleel-ur-rehman-chishti-rounded.png";
import dalouer from "../../../assets/imgs/team/takbir-muna-academy-imam-dalouer-hossain.png";
import ruhul from "../../../assets/imgs/team/takbir-muna-academy-prof-dr-muhammad-ruhul-amin.png";
import hasan from "../../../assets/imgs/team/takbir-muna-academy-ustad-mainuddin-hassan.png";
import styles from "./LearnFromOurTeacher.module.css";
import { useEffect, useState } from "react";
import AboutUs from "../../AboutUs/AboutUs";
import Team from "../../Team/Team";
import TestimonialsGridView from "../../TestimonialsGridView/TestimonialsGridView";
import Banner from "../../Banner/Banner";
import { useRouter } from "next/navigation";
import TeacherCard from "../../TeacherCard/TeacherCard";
import SimpleBackdrop from "../../Backdrop/SimpleBackdrop";
import { apiRequest } from "../../../utils/axiosInstance";
import { getUserData } from "../../../hooks/HelperFunctions";

const LearnFromOurTeacher = (props) => {
  const {
    setOpenSignUpModel
  } = props;



  const [hostName, setHostName] = useState("");
  const [takbirUrl, setTakbirUrl] = useState("");

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const router = useRouter();
  useEffect(() => {
    // Check if window is defined to determine if code is running client-side
    if (typeof window !== "undefined") {
      const hostname = window.location.hostname;
      setHostName(hostname);
    }
  }, []);

  useEffect(() => {
    if (hostName != "") {
      const subdomain = hostName.split(".")[0];
      const url =
        subdomain == "main-stage"
          ? "https://stage.mytakbir.com/"
          : "https://muna.mytakbir.com/";
      setTakbirUrl(url);
    }
  }, [hostName]);

  const cardData = [
    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/imam-dalouer-hossain.png",
      name: "Imam Dalouer Hossain",
      link: "#",
    },

    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/prof-khaleel-ul-rahman-chishti.png",
      name: "Prof. Khaleel ul Rahman Chishti",
      link: "#",
    },

    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/ustadh-abu-samihah-sirajul-islam.png",
      name: "Ustadh AbuSamihah Sirajul Islam",
      link: "https://mytakbir.com/t/abusamihah?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },

    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/dr-suzy-ismail.png",
      name: "Dr. Suzy Ismail",
      link: "https://mytakbir.com/t/suzy-ismail?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },

    {
      img: "https://cdn.mytakbir.com/jayhan/aminah-al-deen/takbir-aminah-al-deen.webp",
      name: "Dr. Aminah Al-Deen",
      link: "https://mytakbir.com/t/aminah-al-deen?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },

    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/Imam Ajmal Masroor.png",
      name: "Imam Ajmal Masroor",
      link: "#",
    },

    // {
    //   img: "https://cdn.mytakbir.com/static-assets/teachers/siahra-malik.png",
    //   name: "Siahra Malik",
    //   link: "https://mytakbir.com/t/siahra-malik-llb-llm?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    // },

    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/kathryn-jones.png",
      name: "Kathryn Jones",
      link: "#",
    },

    {
      img: "https://cdn.mytakbir.com/jayhan/abu-talib-mohammad-monawer/logo/takbir-abu-talib-mohammad-%20monawer.jpg",
      name: "Dr. Abu Talib Mohammad Monawer",
      link: "https://mytakbir.com/t/study-circle?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },

    {
      img: "https://cdn.mytakbir.com/jayhan/dr-haroon-khan/takbir-dr-haroon-khan.jpg",
      name: "Dr. Haroon Khan",
      link: "https://mytakbir.com/t/dr-haroon-khan?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },

    {
      img: "https://cdn.mytakbir.com/jayhan/naima-b-robert/takbir-na'ima-b-robert.png",
      name: "Na'ima B Robert",
      link: "https://mytakbir.com/t/naimabrobert?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },

    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/takbir-dr-nikita-islam-grey.png",
      name: "Dr. Nikita Islam",
      link: "https://mytakbir.com/t/dr-nikita-islam?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },

    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/takbir-dr-wasie-fasih.jfif",
      name: "Dr. Mufti Wasie Fasih Butt",
      link: "https://mytakbir.com/t/muhammad-wasie-fasih-butt?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },

 

 {
      img: "https://cdn.mytakbir.com/jayhan/maryan-ali-mowliid/profile/takbir-maryan-ali-mowliid.jpg",
      name: "Maryan Ali Mowliid",
      link: "https://mytakbir.com/t/maryan-ali-mowliid?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },

    {
      img: "https://cdn.mytakbir.com/jayhan/imam-saeed-purcell/takbir-imam-saeed-purcell.webp",
      name: "Imam Saeed Purcell",
      link: "https://mytakbir.com/t/imam-saeed-purcell?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },

    {
      img: "https://cdn.mytakbir.com/jayhan/dr-main-alqudah/takbir-dr-main-alqudah.webp",
      name: "Dr Main Al Qudah",
      link: "https://mytakbir.com/t/guidancecollege?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk"
    },

   
   {
      img: "https://cdn.mytakbir.com/jayhan/javeria-ahmed/takbir-javeria-ahmed.webp",
      name: "Javeria Ahmed",
      link: "https://mytakbir.com/t/javeriahmed?utm_source=tkbr-home&utm_medium=tkbr-ta-sec&utm_campaign=tkbr-ta-page-lnk",
    },


    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/tkbr-ameena-blake.jpg",
      name: "Ustadha Ameena Blake",
      link: "#",
    },

     {
      img: "https://cdn.mytakbir.com/static-assets/teachers/tkbr-coach-kamrul-hasan.jpg",
      name: "Coach Kamrul Hasan",
      link: "#",
    },

    
    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/tkbr-kaushar-tai.jpg",
      name: "Kaushar Tai",
      link: "#",
    },

   
    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/takbir-asmaa-shehada.jpg",
      name: "Asmaa Shehada",
      link: "#",
    },

    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/takbir-learn-teach-online-halim-rane.jpeg",
      name: "Halim Rane",
      link: "#",
    },

    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/takbir-najat-fradi.JPG",
      name: "Dr. Najat Fradi",
      link: "#",
    },

    {
      img: "https://cdn.mytakbir.com/static-assets/teachers/takbir-ala-a-irsheid.png",
      name: "Ala'a Irsheid",
      link: "#",
    },





    // {
    //   img: "https://cdn.mytakbir.com/static-assets/teachers/kathryn-jones.png",
    //   name: "Kathryn Jones",
    //   link: "#",
    // },
  ];


  const getStartedHandler = async () => {
    const userInfo = getUserData()

    if (userInfo && Object.keys(userInfo).length > 0) {

      setOpenBackdrop(true); // show loading spinner/backdrop

      try {
        const postData = {};

        const response = await apiRequest("/generateLoginCode", "POST", postData);

        const { code } = response;

        if (code) {

          // Construct Become a teacher URL with code
          const appBUrl = `${process.env.NEXT_PUBLIC_BECOME_A_TEACHER_URL}?code=${encodeURIComponent(code)}`;


          window.location.href = appBUrl;
        } else {
          console.error("No code returned from API");
        }

      } catch (error) {
        console.error("Error generating login code:", error);
      } finally {
        setOpenBackdrop(false);
      }
    } else {
      router.push("/teach")
      // console.log("No user found");

      // sessionStorage.setItem("from_become_a_teacher", true);

      // setOpenSignUpModel(true)
    }

  }

  /**
   * close backdrop
   */
  const handleCloseBackdrop = () => {
    setOpenBackdrop(false);
  };

  return (
    <>
      <SimpleBackdrop open={openBackdrop} handleClose={handleCloseBackdrop} />
      <div
        className={styles.Section}
        style={{
          background: `url("https://cdn.mytakbir.com/static-assets/images/takbir-website-hoome-section-background.webp`,
        }}
      >
        <div className={styles.Container}>
          <div className={styles.SectionTitle}>
            Learn directly from <br></br>scholars & teachers of our Deen
          </div>

          <div className={styles.CardBox}>
            {cardData.map((item, i) => (
              <TeacherCard
                img={item.img}
                name={item.name}
                button={true}
                buttonlebel="View teaching page"
                link={item.link}
              />
            ))}
          </div>
          <div className={styles.DividerOuter}>
            <div className={styles.Divider}></div>
          </div>

          <div className={styles.BottomTitle}>
            {" "}
            Ready to reach learners worldwide?
          </div>
          <div className={styles.BottomDescription}>
            Make a global impact with your knowledge & skills.
          </div>
          <div className={styles.ButtonBox}>
            <button
              className={styles.BottomButton}
              onClick={() => getStartedHandler()}
            >
              Join as a teacher
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LearnFromOurTeacher;
